export default {
    'currencies-settings': 'Symbols currency display',
    'show-currency-symbol': 'Show currency symbols',
    'Asking-about-the-date-of-the-bond-accounting-or-cash-before-it-was-created': 'Specify date before creating bond',
    'show-the-dialog-to-choose-the-date-instead-of-adopting-today-date': "Show dialog to choose date (instead of today's date)",
    'open-account-statement-in-new-window': 'open account statement in new window',
    'opening-account-statement-in-new-window-from-accounting-journal': 'opening account statement for entry from accounting journal in a new tab',
}